"use strict";

const FacilityInspectionSiteDocuments = function () {
  const stringKey = "site-documents";
  const tabHeader = "Site Documents";

  var loadListeners = function (data) {};

  var unloadListeners = function () {};

  var getProps = function (data) {
    return {};
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
  };
};

module.exports = FacilityInspectionSiteDocuments();
